import React from "react";
import { useI18n } from "../context/I18nContext";
import { Globe } from "lucide-react";

const LanguageToggle = () => {
  const { lang, setLang, t } = useI18n();

  const btn = (code, label) => (
    <button
      key={code}
      data-testid={`lang-toggle-${code}`}
      onClick={() => setLang(code)}
      className={`px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold transition ${
        lang === code
          ? "bg-[#D63031] text-white shadow-sm"
          : "text-[#2C3E50] hover:bg-white/70"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div
      data-testid="language-panel"
      className="w-full bg-[#FFF5E1] border-b border-[#F39C12]/20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 py-2 flex items-center justify-center sm:justify-end gap-2">
        <span className="inline-flex items-center gap-1.5 text-xs text-[#2C3E50]/70 font-medium mr-1">
          <Globe className="w-3.5 h-3.5" />
          {t("language")}:
        </span>
        <div className="inline-flex bg-white/60 rounded-full p-0.5 border border-[#F39C12]/20">
          {btn("en", t("english"))}
          {btn("gu", t("gujarati"))}
        </div>
      </div>
    </div>
  );
};

export default LanguageToggle;
